export default __webpack_public_path__ + "static/media/zip-picto.e1f321b0.svg";